module.exports = __webpack_public_path__ + "img/zeal.ec3146b6.png";